import { enc } from './core.js';
export function localsApi(c) {
    return {
        list: () => c.get('/locals'),
        create: (body) => c.post('/locals', body),
        get: (localId) => c.get(`/locals/${enc(localId)}`),
        update: (localId, body) => c.patch(`/locals/${enc(localId)}`, body),
        updateBranding: (localId, body) => c.patch(`/locals/${enc(localId)}/branding`, body),
        updateHours: (localId, body) => c.patch(`/locals/${enc(localId)}/hours`, body),
        publish: (localId, body = { published: true }) => c.post(`/locals/${enc(localId)}/publish`, body),
        checkSlug: (slug) => c.get('/locals/check-slug', { query: { slug } }),
    };
}
//# sourceMappingURL=locals.js.map